module.exports = __webpack_public_path__ + "img/touxiang.37c3ea6b.png";